import PropTypes from 'prop-types';

const propTypes = {
  inputRef: PropTypes.func,
  fields: PropTypes.array,
  fieldIndex: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onLoad: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  validationState: PropTypes.oneOf(['none', 'warning', 'error']),
  autoComplete: PropTypes.string,
  maxLength: PropTypes.number
};

const defaultProps = {
  inputRef: () => {},
  fields: [],
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  onLoad: () => {},
  required: false,
  disabled: false,
  placeholder: '',
  validationState: undefined
};

const propDescriptions = {
  inputRef: 'Callback with input reference when the Field is mounted #data',
  fields: 'Array of Fields in the containing Form #data',
  fieldIndex: 'Index of the Field in the containing Form #data',
  onChange: 'Callback with updated value whenever a change is made in the Field #event',
  onFocus: 'Callback when the Field is focused #event',
  onBlur: 'Callback when the Field is blurred #event',
  onLoad: 'Callback when the Field is mounted #event',
  required: 'Is the Field required #validation',
  disabled: 'Is the Field disabled #validation',
  placeholder: 'Placeholder text to be displayed on the Field #visual',
  validationState: 'Prop to identify whether or not the Field is valid #validation',
  autoComplete: 'Prop to indicate whether form should autocomplete or not #validation',
  maxLength: 'Maximum number of characters allowed in the input #validation'
};

const inputProps = {
  propTypes,
  defaultProps,
  propDescriptions
};

export default inputProps;
